import React, { useEffect, useRef } from "react";
import { loadScript } from "~utils";

const PolyvLiveStream = ({ uid, vid, className, width, height }) => {
  const playerWrapper = useRef();
  const playerRef = useRef(null);

  useEffect(() => {
    loadScript(
      "https://player.polyv.net/resp/live-h5-player/latest/liveplayer.min.js"
    ).then(() => {
      if (!playerRef.current) {
        window.setTimeout(() => {
          playerRef.current = window.polyvLivePlayer({
            wrap: `#liveplayer`,
            width: width || window?.innerWidth || "100%",
            height: height || "100%",
            uid: uid,
            vid: vid,
          });
        }, 1000);
      }
    });
    return () => {
      if (playerRef?.current) {
        playerRef.current.destroy();
      }
    };
  }, []);

  return <div className={className} id="liveplayer" ref={playerWrapper} />;
};

export default PolyvLiveStream;
